import { render, staticRenderFns } from "./analogBETTER.vue?vue&type=template&id=a4b64858&scoped=true"
import script from "./analogBETTER.vue?vue&type=script&lang=js"
export * from "./analogBETTER.vue?vue&type=script&lang=js"
import style0 from "./analogBETTER.vue?vue&type=style&index=0&id=a4b64858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b64858",
  null
  
)

export default component.exports